import * as React from "react"
import { toast } from "react-toastify"
import CollectionSite from "../../api/Location/LocationModel/CollectionSite"
import { stateAbbreviationsToCommonWealthState, StateToTimeZone } from "../../api/Location/LocationModel/CommonWealthStateTextMapping"
import { APIError } from "../../api/ObservableFromFetch"
import { GetOrderRequest, ServicePriceTierParameter, SetFFTestDetailVendor, SetTestDetailVendor, SetTestDetailVendorParameters } from "../../api/OrderRequests/SSOOrderRequest"
import { StorageKey } from "../../config/Constants"
import { GetSSOToken } from "../../storage/AuthToken"
import { AppPageWrapper } from "../NavMenu/AppPageWrapper"
import OrderFinish from "../OrderRequests/OrderFinish"
import ProcessingModal from "../ProcessingModal"
import SiteSearch from "../SiteSearch/SiteSearch"

export const TimeZoneMapping: {[key: string]: string} = {
  "CST": "Central Standard Time",
  "AKST": "Alaskan Standard Time",
  "MST": "Mountain Standard Time",
  "HST": "Hawaiian Standard Time",
  "EDT": "Eastern Daylight Time",
  "PST": "Pacific Standard Time",
  "EST": "Eastern Standard Time"
}

interface SiteSearchPageState {
  formFoxTestAN: number
  sendLink: boolean
  sendCallback: boolean
  isLoading: boolean
  ssoToken: string
  isSaving: boolean
  showFinish: boolean
  isFFOrder: boolean
  spinnerMessage: string
}
export default class SiteSearchPage extends React.PureComponent<{}, SiteSearchPageState> {
  state: SiteSearchPageState = {
    formFoxTestAN: 0,
    sendLink: false,
    sendCallback: false,
    isLoading: true,
    ssoToken: GetSSOToken(),
    isSaving: false,
    showFinish: false,
    isFFOrder: false,
    spinnerMessage: "Data is loading.."
  }

  componentDidMount() {
    localStorage.removeItem(StorageKey.CanViewOrderFinish)
    localStorage.removeItem(StorageKey.OrderedServices)
    localStorage.removeItem(StorageKey.SavedOrderData)
    localStorage.removeItem(StorageKey.OrderDonorSiteSelect)
    localStorage.removeItem(StorageKey.FromSelectionInbox)
    this.retrieveFFTestAN()
  }

  retrieveFFTestAN = () => {
    GetOrderRequest(this.state.ssoToken).subscribe(
      data => this.setState({ formFoxTestAN: data.FormFoxTestAN, sendLink: data.SendLink, sendCallback: data.SendCallback, isFFOrder: data.IsFFOrder, isLoading: false }),
      error => this.handleAPIError(error, { isLoading: false })
    )
  }

  updateOrder = (site: CollectionSite, params: {сallbackLink?: string, referenceTestID: number}) => {
    this.setState({ isSaving: true, spinnerMessage: "Saving.." })
    let timezone = ""
    let serviceTiers: ServicePriceTierParameter[] = []

    if (site.State) {
      const state = stateAbbreviationsToCommonWealthState[site.State]
      const statetimezone = StateToTimeZone[state]
      timezone = TimeZoneMapping[statetimezone] || ""
    }
    if (this.state.isFFOrder && !!site.SiteServices) {
      serviceTiers = site.SiteServices.map(el => { return {ServiceCode: el.Code, ServicePriceTier: (el.PriceTier ?? "")}})
    }

    const parameters: SetTestDetailVendorParameters = {
      formFoxTestAN: this.state.formFoxTestAN,
      collectionVendorID: site.VendorID,
      formFoxVendorAN: site.FormFoxVendorAN || 0,
      FFVendorCode: site.Code,
      collectorVendorName: site.Name || "",
      servicePriceTiers: serviceTiers,
      ssoToken: this.state.ssoToken,
      timeZone: timezone,
      sendLink: this.state.sendLink,
      sendCallback: this.state.sendCallback,
      isFFOrder: this.state.isFFOrder,
      ReferenceTestID: params.referenceTestID,
      ProceedImmediately:false,
      ExtendExpirationHours: 0,
      IsMarketPlace: site?.IsMarketPlace || false,
      ClinicWasUpdated: true,
    }

    if (this.state.isFFOrder) {
      SetFFTestDetailVendor(parameters).subscribe(
        data => {
          const message = !!data && data.length > 0 ? data : "Your order has been updated."
          toast.success(message)
          if (!!params.сallbackLink && params.сallbackLink != "") {
            this.setState({spinnerMessage: "Redirecting..."})
            setTimeout(() => {
              this.setState({ isSaving: false, showFinish: false })
              window.location.replace(params.сallbackLink || "")
            }, 3000);
          }
          else {
            this.setState({ isSaving: false, showFinish: true })
          }
        },
        error => this.handleAPIError(error, { isSaving: false })
      )
    }
    else {
      SetTestDetailVendor(parameters).subscribe(
        data => {
          localStorage.setItem(StorageKey.SavedOrderData, JSON.stringify(data))
          this.setState({ isSaving: false, showFinish: true })
        },
        error => this.handleAPIError(error, { isSaving: false })
      )
    }
  }

  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }

  render() {
    const { isLoading, formFoxTestAN, isSaving, showFinish } = this.state;

    return <AppPageWrapper showNav={true}>
      {(isLoading || isSaving) && <ProcessingModal message={this.state.spinnerMessage} />}
      {!isLoading && !showFinish && <SiteSearch formFoxTestAN={formFoxTestAN} isFFOrder={this.state.isFFOrder} isSSO={true} onSiteSelect={(site, callbackAction) => this.updateOrder(site, callbackAction)} />}
      {showFinish && <OrderFinish isSSO isFFOrder={this.state.isFFOrder} />}
    </AppPageWrapper>
  }
}
